module.exports = __webpack_public_path__ + "static/media/retake.1ab88a24.svg";